import { NativeModulesProxy, EventEmitter, Subscription, Platform } from 'expo-modules-core';

// Import the native module. On web, it will be resolved to CloverAndroidServices.web.ts
// and on native platforms to CloverAndroidServices.ts
import CloverAndroidServicesModule from './src/CloverAndroidServicesModule';
import {
  ChangeEventPayload,
  CloverServicesAndroidApiServiceConnectProps,
  CloverServicesAndroidApiServiceDisconnectProps,
  CloverServicesAndroidApiServicePrintingProps,
} from './src/CloverAndroidServices.types';

//const emitter = new EventEmitter(CloverAndroidServicesModule ?? NativeModulesProxy.CloverAndroidServices);

const nativeModule = Platform.OS === 'web' 
  ? CloverAndroidServicesModule 
  : (CloverAndroidServicesModule ?? NativeModulesProxy.CloverAndroidServices);
const emitter = new EventEmitter(nativeModule);

export function addChangeListener(listener: (paymentData: ChangeEventPayload) => void): Subscription {
  return emitter.addListener<ChangeEventPayload>('onChangePayment', listener);
}

export function initializePaymentConnector({
  cloverAppId,
  isForSitefApp,
}: CloverServicesAndroidApiServiceConnectProps): string {
  return CloverAndroidServicesModule.initializePaymentConnector(cloverAppId, isForSitefApp);
}

export async function printReceipt({
  orderToPrintableString,
  isCloverFlex,
  isFromSitefApp,
  paymentMethod,
  verificationMethodAssigned,
  isRefund,
  discountPercentage,
  paymentWasSubsidized,
}: CloverServicesAndroidApiServicePrintingProps): Promise<boolean> {
  return await CloverAndroidServicesModule.printReceiptAfterSale(
    orderToPrintableString,
    isCloverFlex,
    isFromSitefApp,
    paymentMethod,
    verificationMethodAssigned,
    isRefund,
    discountPercentage,
    paymentWasSubsidized,
  );
}

export async function checkIfPrinterHasPaperLoaded(): Promise<boolean> {
  return CloverAndroidServicesModule.checkIfPrinterHasPaperLoaded();
}

export function disconnectCloverDevice({ isForSitefApp }: CloverServicesAndroidApiServiceDisconnectProps): string {
  return CloverAndroidServicesModule.disposeCloverConnection(isForSitefApp);
}

export { ChangeEventPayload };
